import { Button } from '@/shared/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/dialog';
import type { ReviewLink } from './types';

/**
 * Revoking cannot be undone - the dentist's link stops working at once and the
 * lab would have to send a new one - so it asks first.
 */
export function RevokeDialog({
  link,
  pending,
  onCancel,
  onConfirm,
}: {
  link: ReviewLink | null;
  pending: boolean;
  onCancel: () => void;
  onConfirm: (link: ReviewLink) => void;
}) {
  return (
    <Dialog
      open={link !== null}
      onOpenChange={(open) => {
        if (!open) onCancel();
      }}
    >
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Revoke this link?</DialogTitle>
          <DialogDescription>
            {link
              ? `${link.dentist.name ?? link.dentist.email ?? 'The dentist'} will no longer be able to open the design for ${link.patientRef}. To share it again you will need to send a new link.`
              : null}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel} disabled={pending}>
            Keep link
          </Button>
          <Button
            variant="destructive"
            disabled={pending || !link}
            onClick={() => {
              if (link) onConfirm(link);
            }}
          >
            Revoke link
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
